// extracted by mini-css-extract-plugin
export default {"overlay":"FlowModal_overlay__Ocpmx","card":"FlowModal_card__I0iUm","header":"FlowModal_header__QVOuX","closeBtn":"FlowModal_closeBtn__tu+y6","body":"FlowModal_body__CKwwQ"};